import { Link } from 'react-router-dom';

export type SettingsTab =
  | 'profile'
  | 'preferences'
  | 'location'
  | 'interests'
  | 'privacy'
  | 'notifications'
  | 'account';

interface NavItem {
  id: SettingsTab;
  icon: string;
  label: string;
  badge?: string;
}

const navItems: NavItem[] = [
  { id: 'profile', icon: 'ri-user-line', label: 'Profil' },
  { id: 'preferences', icon: 'ri-equalizer-line', label: 'Tercihler' },
  { id: 'location', icon: 'ri-map-pin-line', label: 'Konum & Dil' },
  { id: 'interests', icon: 'ri-heart-3-line', label: 'İlgi Alanları' },
  { id: 'privacy', icon: 'ri-shield-line', label: 'Gizlilik & Güvenlik' },
  { id: 'notifications', icon: 'ri-notification-3-line', label: 'Bildirimler' },
  { id: 'account', icon: 'ri-settings-3-line', label: 'Hesap', badge: 'Ücretsiz' },
];

interface SettingsSidebarProps {
  active: SettingsTab;
  onTabChange: (tab: SettingsTab) => void;
}

const SettingsSidebar = ({ active, onTabChange }: SettingsSidebarProps) => {
  return (
    <aside className="w-full lg:w-64 flex-shrink-0">
      {/* User mini card */}
      <div className="flex items-center gap-3 p-4 rounded-2xl bg-white/3 border border-white/8 mb-4">
        <div className="relative w-12 h-12 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-cyan-500/30 to-violet-600/30 border border-white/15">
          <img
            src="https://readdy.ai/api/search-image?query=young%20person%20casual%20portrait%2C%20neutral%20expression%2C%20minimal%20background%2C%20avatar%20style%2C%20soft%20lighting%2C%20realistic%20photo&width=96&height=96&seq=useravatar&orientation=squarish"
            alt="Profil"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-white font-semibold text-sm truncate">kullanici_42</div>
          <div className="text-white/40 text-xs truncate">ornek@email.com</div>
        </div>
        <div className="px-2 py-1 rounded-full bg-white/8 border border-white/10 text-white/40 text-xs whitespace-nowrap">
          Ücretsiz
        </div>
      </div>

      {/* Nav */}
      <nav className="flex flex-col gap-1">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-left transition-all duration-200 cursor-pointer ${
              active === item.id
                ? 'bg-cyan-500/12 border border-cyan-500/25 text-cyan-400'
                : 'text-white/55 hover:bg-white/5 hover:text-white/80 border border-transparent'
            }`}
          >
            <div
              className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
                active === item.id
                  ? 'bg-cyan-500/20 text-cyan-400'
                  : 'bg-white/5 text-white/35'
              }`}
            >
              <i className={`${item.icon} text-sm`} />
            </div>
            <span className="flex-1 whitespace-nowrap">{item.label}</span>
            {item.badge && (
              <span className="px-2 py-0.5 rounded-full bg-white/8 text-white/30 text-xs whitespace-nowrap">
                {item.badge}
              </span>
            )}
            {active === item.id && (
              <i className="ri-arrow-right-s-line text-cyan-400/60 text-base" />
            )}
          </button>
        ))}
      </nav>

      {/* Upgrade CTA */}
      <div className="mt-4 p-4 rounded-2xl bg-gradient-to-br from-yellow-500/10 to-orange-500/10 border border-yellow-500/25">
        <div className="flex items-center gap-2 mb-2">
          <i className="ri-vip-crown-line text-yellow-400 text-sm" />
          <span className="text-yellow-400 font-bold text-sm">Premium'a Geç</span>
        </div>
        <p className="text-white/40 text-xs leading-relaxed mb-3">
          Cinsiyet ve ülke filtrelerine erişim için Premium'u dene.
        </p>
        <Link
          to="/premium"
          className="block text-center py-2 rounded-xl bg-gradient-to-r from-yellow-500 to-orange-500 text-black text-xs font-extrabold hover:from-yellow-400 hover:to-orange-400 transition-all cursor-pointer whitespace-nowrap"
        >
          Keşfet →
        </Link>
      </div>
    </aside>
  );
};

export default SettingsSidebar;
